<script>
  import { _ as t } from "svelte-i18n";
  import { Button } from "t2c-components";
</script>

<div class="wrapper">
  <div class="inner">
    <svg class="icon" fill="none" stroke="white" viewBox="-2 -2 28 28">
      <use xlink:href="#nopreview" />
    </svg>
    <p>{$t("document.noPreview")}</p>
    <Button style="filled" on:click text={$t("document.download")} />
  </div>
</div>

<style>
  .wrapper {
    background-color: #777676;
    text-align: center;
    min-height: 100vh;
  }

  .inner {
    padding-top: 128px;
    margin: 0 24px;
  }

  p {
    margin: 0;
    padding: 24px 0;
    color: white;
    font-size: 24px;
    font-weight: 300;
  }

  .icon {
    display: inline-block;
    width: 128px;
    height: 128px;
    margin: 0 5px;
  }
</style>
